import { useState, useEffect, useRef } from "react";

import bonaventura_logo from '../../assets/bonaventura_logo.png';
import fabcycle_logo    from '../../assets/fabcycle_logo.png';
import gameology_logo   from '../../assets/gameology_logo.png';
import ferf_logo        from '../../assets/ferf_logo.png';
import kef_logo         from '../../assets/kef_logo.png';
import levelsix_logo    from '../../assets/levelsix_logo.png';
import mcobeauty_logo   from '../../assets/mcobeauty_logo.png';
import mrsofttop_logo   from '../../assets/mrsofttop_logo.png';
import rackcity_logo    from '../../assets/rackcity_logo.png';

const logos = [
    { name: "Ferf",         src: ferf_logo        },
    { name: "Fabcycle",     src: fabcycle_logo     },
    { name: "Gameology",    src: gameology_logo    },
    { name: "Rack City",    src: rackcity_logo     },
    { name: "Mr. Soft Top", src: mrsofttop_logo    },
    { name: "MCo Beauty",   src: mcobeauty_logo    },
    { name: "KEF",          src: kef_logo          },
    { name: "Level Six",    src: levelsix_logo     },
    { name: "Bonaventura",  src: bonaventura_logo  },
];

const GRID_SIZE = 8;
const SWAP_INTERVAL = 1800;
const ANIM_DURATION = 400;

function shuffle(arr) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

function pickNext(pool, excludeNames) {
    const available = pool.filter((l) => !excludeNames.includes(l.name));
    if (!available.length) return pool[Math.floor(Math.random() * pool.length)];
    return available[Math.floor(Math.random() * available.length)];
}

function LogoSlot({ logo, animState }) {
    const animClass =
        animState === "exiting"
            ? "animate-logo-out"
            : animState === "entering"
                ? "animate-logo-in"
                : "";

    return (
        <div
            className={`flex items-center justify-center h-14 px-4 rounded-xl select-none ${animClass}`}
        >
            <img
                src={logo.src}
                alt={logo.name}
                className="h-7 object-contain"
            />
        </div>
    );
}

export default function LogoTicker() {
    const [slots, setSlots] = useState(() =>
        shuffle(logos)
            .slice(0, GRID_SIZE)
            .map((logo) => ({ logo, animState: "idle" }))
    );

    const tickRef  = useRef(0);
    const slotsRef = useRef(slots);
    slotsRef.current = slots;

    useEffect(() => {
        const timer = setInterval(() => {
            const idx = tickRef.current % GRID_SIZE;
            tickRef.current++;

            const currentNames = slotsRef.current.map((s) => s.logo.name);
            const next = pickNext(logos, currentNames);

            // Phase 1: exit
            setSlots((prev) =>
                prev.map((s, i) => (i === idx ? { ...s, animState: "exiting" } : s))
            );

            // Phase 2: swap + enter
            setTimeout(() => {
                setSlots((prev) =>
                    prev.map((s, i) =>
                        i === idx ? { logo: next, animState: "entering" } : s
                    )
                );

                // Phase 3: idle
                setTimeout(() => {
                    setSlots((prev) =>
                        prev.map((s, i) =>
                            i === idx ? { ...s, animState: "idle" } : s
                        )
                    );
                }, ANIM_DURATION);
            }, ANIM_DURATION);
        }, SWAP_INTERVAL);

        return () => clearInterval(timer);
    }, []);

    return (
        <>
            <style>{`
        @keyframes logo-out {
          from { opacity: 1; transform: translateY(0); }
          to   { opacity: 0; transform: translateY(-18px); }
        }
        @keyframes logo-in {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .animate-logo-out { animation: logo-out ${ANIM_DURATION}ms cubic-bezier(0.4,0,0.2,1) forwards; }
        .animate-logo-in  { animation: logo-in  ${ANIM_DURATION}ms cubic-bezier(0.4,0,0.2,1) forwards; }
      `}</style>

            <div className="py-10 text-center">
                <div className="grid grid-cols-4 gap-x-8 gap-y-6 max-w-4xl mx-auto px-4" style={{
                    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                }}>
                    {slots.map((slot, i) => (
                        <LogoSlot key={i} logo={slot.logo} animState={slot.animState} />
                    ))}
                </div>
            </div>
        </>
    );
}